module.exports = __webpack_public_path__ + "static/media/line-icon.c6c6fbf6.svg";